module.exports = __webpack_public_path__ + "img/download_qr_code.8673beb.png";